import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b2e98e9c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b2e98e9c&prod&lang=less"
import style1 from "./index.vue?vue&type=style&index=1&id=b2e98e9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e98e9c",
  null
  
)

export default component.exports